export default {
  "article.title": "¿Qué es una hoja de cálculo de USFans? Guía completa para principiantes",
  "article.meta_description": "Aprende qué es una hoja de cálculo de USFans, por qué la usan los compradores, cómo organizarla y qué comprobar antes de comprar. Una guía fácil con consejos prácticos.",
  "article.breadcrumb_home": "Inicio",
  "article.breadcrumb_current": "Guía de USFans Spreadsheet",
  "article.updated": "Última actualización",
  "article.read_time": "6 min de lectura",
  "article.toc": "Índice de contenidos",
  "article.toc_1": "¿Qué es una hoja de cálculo de USFans?",
  "article.toc_2": "¿Por qué usar una hoja al comprar?",
  "article.toc_3": "Cómo organizar una hoja de cálculo de USFans",
  "article.toc_4": "Columnas comunes a incluir",
  "article.toc_5": "Consejos para principiantes",
  "article.toc_6": "Preguntas frecuentes",

  "article.intro": "Una hoja de cálculo de USFans es un recurso estructurado que muchos compradores usan para organizar, comparar y hacer seguimiento de productos mientras navegan. Esta guía explica qué es una hoja de cálculo de USFans, por qué puede ser útil, cómo configurarla de forma eficaz y qué tener en cuenta antes de realizar una compra.",

  "article.h2_1": "¿Qué es una hoja de cálculo de USFans?",
  "article.p_1a": "En términos sencillos, una hoja de cálculo de USFans es una tabla que se usa para recopilar información de productos en un solo lugar. En lugar de desplazarte por un catálogo largo e intentar recordar lo que viste, puedes registrar los artículos que te interesan: su categoría, referencia, talla, precio y cualquier nota sobre calidad o envío.",
  "article.p_1b": "La hoja no es una herramienta oficial. Es una forma práctica de dar estructura a tu investigación de compras. Muchas personas crean su propia versión y añaden solo las columnas que les importan.",

  "article.h2_2": "¿Por qué usar una hoja al comprar?",
  "article.p_2a": "Una hoja ayuda de varias formas prácticas. Primero, mantiene todas tus opciones visibles a la vez, para que puedas comparar productos lado a lado sin abrir muchas pestañas. Segundo, reduce la posibilidad de olvidar un artículo que te gustó. Tercero, te da un registro claro de lo que estás considerando, útil si planeas comprar durante varios días.",
  "article.p_2b": "Es especialmente útil cuando comparas productos similares entre categorías, por ejemplo, comprobando en qué se diferencia una chaqueta de una sudadera en cuanto a tallas disponibles, referencias y notas.",

  "article.h2_3": "Cómo organizar una hoja de cálculo de USFans",
  "article.p_3a": "No necesitas software especial. Una hoja simple en cualquier aplicación de hojas de cálculo funciona bien. Empieza con una fila de encabezado que nombre cada columna y luego añade una fila por cada producto que estés considerando.",
  "article.p_3b": "Mantén un diseño simple. El objetivo es la claridad, no la complejidad. Siempre puedes añadir o quitar columnas más tarde según cambien tus necesidades.",

  "article.h2_4": "Columnas comunes a incluir",
  "article.table_header": "Un diseño práctico para empezar",
  "article.table_col1": "Columna",
  "article.table_col2": "Para qué sirve",
  "article.row1_col1": "Producto",
  "article.row1_col2": "El nombre o la descripción del artículo",
  "article.row2_col1": "Categoría",
  "article.row2_col2": "Zapatos, sudaderas, chaquetas, etc.",
  "article.row3_col1": "Referencia",
  "article.row3_col2": "Un código o SKU para identificar el artículo",
  "article.row4_col1": "QC",
  "article.row4_col2": "Notas sobre control de calidad o inspección",
  "article.row5_col1": "Envío",
  "article.row5_col2": "Método de envío o notas de entrega",
  "article.row6_col1": "Estado",
  "article.row6_col2": "Considerando, pedido o recibido",

  "article.h2_5": "Consejos para principiantes",
  "article.tip_1": "Empieza con una lista corta y añade columnas solo cuando las necesites.",
  "article.tip_2": "Usa una referencia o SKU consistente para poder encontrar el mismo artículo de nuevo.",
  "article.tip_3": "Registra la fecha y la fuente de cualquier información que anotes.",
  "article.tip_4": "Guarda el precio y los detalles de envío como una nota y verifícalos en el sitio principal antes de comprar.",

  "article.faq_title": "Preguntas frecuentes",
  "article.faq_q1": "¿Necesito una app especial para hacer una hoja de cálculo de USFans?",
  "article.faq_a1": "No. Cualquier hoja de cálculo o incluso una nota simple funciona. Lo importante es un diseño claro y consistente.",
  "article.faq_q2": "¿La hoja es un producto oficial de USFans?",
  "article.faq_a2": "No. Es un método general de organización usado por compradores, no una herramienta oficial de ningún vendedor.",
  "article.faq_q3": "¿En qué se diferencia de simplemente navegar por el catálogo?",
  "article.faq_a3": "Navegar te muestra productos uno a uno. Una hoja te permite mantener tu lista corta junta y compararla directamente.",

  "article.cta_title": "¿Listo para ponerlo en práctica?",
  "article.cta_body": "Ahora que entiendes cómo funciona una hoja de cálculo de USFans, visita el sitio principal para explorar productos y empezar a crear tu propia lista.",
  "article.cta_button": "Explorar productos en el sitio principal",
  "article.back_home": "Volver al inicio",
  "article.related_title": "Recursos relacionados",
  "article.related_1": "Reseña de USFans",
  "article.related_2": "Guía de costos de envío de USFans",
  "article.related_3": "¿Es USFans legítimo?",
};